import React from "react";
import {
  DefaultButton,
  Dropdown,
  IBasePickerSuggestionsProps,
  IPersonaProps,
  ISuggestionItemProps,
  NormalPeoplePicker,
  PeoplePickerItemSuggestion,
  PrimaryButton,
  Stack,
} from "@fluentui/react";
import { Formik } from "formik";
import { assignOrDeAssignEscalationMatrix } from "../../../services/customers/CustomerService";
import { IAssignedEscalationMatrix, IEscalationMatrix } from "../../../vm";
import {
  ASSIGNED_ESCALATION_MATRIX_TYPE,
  childrenGap,
  EMATRIX_DIC,
  EMATRIX_LEVELS_DICT,
} from "../../common/Constants";
import CustomDrawer from "../../common/CustomDrawer";
import { ToastContext } from "../../common/ToastProvider";
import * as yup from "yup";
import { getAllEscalationMatrix } from "../../../services/escalationMatrix/EscalationMatrixService";
import ManageEscalationMatrix from "../../escalation-matrix/ManageEscalationMatrix";
import { Loading } from "../../../services/Loading";
// import Icon from "@mdi/react";

// const idsSchema = yup.object().shape({
//   id: yup.string(),
// });

const aEMSchema = yup.object().shape({
  type: yup.string().required("required"),
  //   escalationMatrixIds: yup.array().of(idsSchema),
});

export interface ManageAEmDialogProps {
  customerId: string;
  handleDialogClose: any;
  handleLoading: any;
  data?: IAssignedEscalationMatrix;
  allEscalationMatrix: IAssignedEscalationMatrix[];
}

const ManageAEmDialog: React.FC<ManageAEmDialogProps> = ({
  customerId,
  handleDialogClose,
  handleLoading,
  data,
  allEscalationMatrix,
}) => {
  //state
  const [type, setType] = React.useState(data ? data.type : "");
  const [
    selectedEscalationMatrix,
    setSelectedEscalationMatrix,
  ] = React.useState([] as IPersonaProps[]);
  const [state, setState] = React.useState({
    assignedEm: {
      type: "",
      escalationMatrixIds: [],
      customerId: customerId,
      escalationMatrixes: [],
      ...data,
    },
    isLoading: false,
    tempEscalationMatrixList: [],
    // selectedEscalationMatrix: [],
    manageAddEmDialog: {
      isOpen: false,
      data: undefined,
    },
    // assignEmType: [...ASSIGNED_ESCALATION_MATRIX_TYPE],
  } as {
    assignedEm: IAssignedEscalationMatrix;
    isLoading: boolean;
    tempEscalationMatrixList: any;
    // selectedEscalationMatrix: IPersonaProps[];
    // assignEmType: IDropdownOption[];
    manageAddEmDialog: {
      isOpen: boolean;
      data?: IEscalationMatrix;
    };
  });

  // hooks
  React.useEffect(() => {
    let selectedEscalationMatrix: IPersonaProps[] = [];
    // let assignEmType = [...state.assignEmType];
    // let escalationMatrix = [...allEscalationMatrix];

    if (data && data.escalationMatrixes && data.escalationMatrixIds) {
      data.escalationMatrixes.forEach((em) => {
        selectedEscalationMatrix.push({
          id: em.id,
          text: em.name + `(${EMATRIX_DIC[em.type] || 'N/A'} - ${EMATRIX_LEVELS_DICT[em.level] || 'N/A'})`,
        });
      });
    }
    // if (escalationMatrix && escalationMatrix.length > 0) {
    //   escalationMatrix.forEach((item) => {
    //     assignEmType = assignEmType.filter((ele) => ele.key !== item.type);
    //   });
    // }
    setState({
      ...state,
      // selectedEscalationMatrix,
      // assignEmType,
    });
    setSelectedEscalationMatrix(selectedEscalationMatrix);
  }, []);

  //custom hooks
  const { showToast } = React.useContext(ToastContext);

  const closeAddDialog = (data?: IAssignedEscalationMatrix) => {
    handleDialogClose(data);
  };

  const pickerSuggestionsProps: IBasePickerSuggestionsProps = {
    noResultsFoundText: "No Escalation matrix found",
  };

  const onRenderSuggestionsItem = (personaProps: IPersonaProps, suggestionsProps: ISuggestionItemProps<IPersonaProps>) => (
    <PeoplePickerItemSuggestion
      personaProps={personaProps}
      suggestionsProps={suggestionsProps}
      styles={{ personaWrapper: { width: '100%' } }}
    />
  );

  // const getTypeOptions = () => {
  //   let escalationMatrix = [...allEscalationMatrix];
  //   let assignEmType: IDropdownOption[] = [];
  //   if (escalationMatrix && escalationMatrix.length > 0) {
  //     escalationMatrix.forEach((item) => {
  //       assignEmType = ASSIGNED_ESCALATION_MATRIX_TYPE.filter(
  //         (ele) => ele.key !== item.type
  //       );
  //     });
  //     return assignEmType;
  //   } else {
  //     return ASSIGNED_ESCALATION_MATRIX_TYPE;
  //   }
  // };

  const onFilterChanged = async (
    filterText: string,
    tagList?: IPersonaProps[]
  ): Promise<IPersonaProps[]> => {
    if (filterText && filterText.length >= 2) {
      let result = await getAllEscalationMatrix({
        search: filterText,
        role: type ? type : "",
        customerId
      });
      if (result?.success) {
        let escalationMatrix: IPersonaProps[] = [];
        let tempEscalationMatrixList = [...state.tempEscalationMatrixList];
        result?.data.forEach((item) => {
          tempEscalationMatrixList.push(item);

          escalationMatrix.push({
            // key: item._id as string,
            // name: item.firstName + " " + item.lastName,
            // data:  item as IPersonaProps
            text: item.name + ` (${EMATRIX_DIC[item.type] || 'N/A'} - ${EMATRIX_LEVELS_DICT[item.level] || 'N/A'})`,
            secondaryText: item.email,
            id: item._id,
          });
        });
        tagList?.forEach((tag) => {
          escalationMatrix = escalationMatrix.filter((e) => e.id !== tag.id);
        });
        setState({ ...state, tempEscalationMatrixList });
        return escalationMatrix;
      } else {
        return [];
      }
    }
    return [];
  };

  const handleAddEmDialogClose = (data: IEscalationMatrix) => {
    if (data) {
      // let selectedEscalationMatrix = [...state.selectedEscalationMatrix];
      let selectedEscalationMatrixs = [...selectedEscalationMatrix];
      // let escalationMatrixIds = [...state.assignedEm.escalationMatrixIds];
      let escalationMatrixIds: any = [];

      // let escalationMatrixes = [
      //   ...(state.assignedEm.escalationMatrixes as any),
      // ];

      let escalationMatrixes: any = [];

      selectedEscalationMatrixs.push({
        id: data._id,
        text: data.name + `(${EMATRIX_DIC[data.type] || 'N/A'} - ${EMATRIX_LEVELS_DICT[data.level] || 'N/A'})`,
      });

      selectedEscalationMatrixs.forEach((m) => {
        escalationMatrixIds.push(m.id as string);
      });

      selectedEscalationMatrixs.forEach((m) => {
        escalationMatrixes.push({
          id: m.id as string,
          text: m.text,
        });
      });

      setState({
        ...state,
        // selectedEscalationMatrix,
        assignedEm: {
          ...state.assignedEm,
          escalationMatrixIds,
          escalationMatrixes,
        },
        manageAddEmDialog: {
          isOpen: false,
          data: undefined,
        },
      });
      setSelectedEscalationMatrix(selectedEscalationMatrixs);
      showToast("Escalation matrix added successfully", "success");
    } else {
      setState({
        ...state,
        manageAddEmDialog: {
          isOpen: false,
          data: undefined,
        },
      });
    }
  };

  const handleLoadng = () => {
    setState({
      ...state,
      isLoading: !state.isLoading,
    });
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <CustomDrawer
        title={"Assign Escalation Matrix"}
        handelOpen={true}
        onClose={() => closeAddDialog()}
      >
        <Stack>
          <Formik
            enableReinitialize
            initialValues={state.assignedEm}
            validationSchema={aEMSchema}
            onSubmit={async (
              values: IAssignedEscalationMatrix,
              { setSubmitting }
            ) => {
              let obj = { ...values };
              handleLoading();
              let result = await assignOrDeAssignEscalationMatrix(obj);
              handleLoading();
              if (result.success) {
                closeAddDialog(result.data);
              } else {
                showToast(
                  result?.message || `Error while assign escalation matrix`,
                  "error"
                );
              }
              setSubmitting(false);
            }}
          >
            {({
              handleSubmit,
              setFieldValue,
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
            }) => (
              <form onSubmit={handleSubmit}>
                <Stack wrap tokens={childrenGap} className="pt-16">
                  <Stack.Item className="custom-dropdown mb-30">
                    <Dropdown
                      options={ASSIGNED_ESCALATION_MATRIX_TYPE}
                      selectedKey={values.type}
                      onChange={(e, item) => {
                        setFieldValue("type", item?.key);
                        setType((item?.key || "") as string);
                        // setState({
                        //   ...state,
                        //   assignedEm: {
                        //     ...state.assignedEm,
                        //     type: item?.key as string,
                        //   },
                        // });
                      }}
                      disabled={state.assignedEm._id !== undefined}
                      label="Function"
                      // label="Type"
                      placeholder="Select an option"
                      errorMessage={
                        (errors.type && touched.type && errors.type) as string
                      }
                    />
                  </Stack.Item>
                  {values.type !== "" && (
                    <>
                      <Stack.Item>
                        <Stack
                          horizontal
                          horizontalAlign="space-between"
                          wrap
                          tokens={childrenGap}
                        >
                          <Stack.Item grow={1}>
                            <NormalPeoplePicker
                              inputProps={{
                                placeholder:
                                  "Search escalation matrix by name/email/type...",
                              }}
                              onResolveSuggestions={onFilterChanged}
                              removeButtonAriaLabel="Remove"
                              // defaultSelectedItems={state.selectedEscalationMatrix}
                              selectedItems={selectedEscalationMatrix}
                              pickerSuggestionsProps={pickerSuggestionsProps}
                              disabled={values.type === ""}
                              onChange={(items: any) => {
                                let escalationMatrixIds: any = [];
                                let escalationMatrixes: any = [];
                                items.forEach((element: any) => {
                                  escalationMatrixIds.push(element.id);
                                  escalationMatrixes.push(element);
                                });
                                setFieldValue(
                                  "escalationMatrixes",
                                  escalationMatrixes
                                );
                                setFieldValue(
                                  "escalationMatrixIds",
                                  escalationMatrixIds
                                );
                                setSelectedEscalationMatrix(escalationMatrixes);
                                // setState({
                                //   ...state,
                                //   assignedEm: {
                                //     ...state.assignedEm,
                                //     escalationMatrixIds: selectedItems,
                                //   },
                                // });
                                // console.log(selectedItems);
                              }}
                              onRenderSuggestionsItem={onRenderSuggestionsItem}
                            />
                          </Stack.Item>
                          <Stack.Item align="center">
                            {/* <TooltipHost
                              content={`Add Escalation Matrix`}
                              id={`editEm`}
                              calloutProps={{ gapSpace: 0 }}
                              styles={{ root: { display: "inline-block" } }}
                            >
                              <span
                                onClick={() =>
                                  values.type !== "" &&
                                  setState({
                                    ...state,
                                    manageAddEmDialog: {
                                      ...state.manageAddEmDialog,
                                      isOpen: true,
                                    },
                                  })
                                }
                              >
                                <Icon
                                  path={mdiAccountPlus}
                                  size={0.8}
                                  className="pointer"
                                  color={
                                    values.type !== ""
                                      ? THEME.palette.themePrimary
                                      : THEME.palette.white
                                  }
                                />
                              </span>
                            </TooltipHost> */}
                            <PrimaryButton
                              text="Add Escalation Matrix"
                              disabled={values.type === ""}
                              onClick={() =>
                                setState({
                                  ...state,
                                  manageAddEmDialog: {
                                    ...state.manageAddEmDialog,
                                    isOpen: true,
                                  },
                                })
                              }
                            />
                          </Stack.Item>
                        </Stack>
                      </Stack.Item>
                    </>
                  )}

                  <Stack.Item>
                    <Stack
                      horizontal
                      wrap
                      tokens={childrenGap}
                      horizontalAlign="end"
                      className="pt-16"
                    >
                      <DefaultButton
                        text="Cancel"
                        onClick={() => closeAddDialog()}
                        className="borderless-btn"
                      />
                      <PrimaryButton type="submit" text={"Assign"} />
                    </Stack>
                  </Stack.Item>
                </Stack>
              </form>
            )}
          </Formik>
        </Stack>
        {state.manageAddEmDialog.isOpen && (
          <ManageEscalationMatrix
            handleLoading={handleLoadng}
            handleDialogclose={(data: IEscalationMatrix) =>
              handleAddEmDialogClose(data)
            }
            customerId={customerId}
            eMType={type}
          />
        )}
      </CustomDrawer>
    </React.Fragment>
  );
};

export default ManageAEmDialog;
